import { render, staticRenderFns } from "./AddressView.vue?vue&type=template&id=094f6145&scoped=true"
import script from "./AddressView.vue?vue&type=script&lang=js"
export * from "./AddressView.vue?vue&type=script&lang=js"
import style0 from "./AddressView.vue?vue&type=style&index=0&id=094f6145&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094f6145",
  null
  
)

export default component.exports